import { Component, EventEmitter, HostBinding, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import * as moment from 'moment';
import { combineLatest } from 'rxjs';
import { CleanSubscriptions } from 'src/app/core/classes/clean-subcriptions';
import { BrowserPreference } from 'src/app/core/services/browser-preferences.service';
import { ResponsiveService } from 'src/app/core/services/responsive.service';
import { UtilService } from 'src/app/core/services/util.service';

@Component({
  selector: 'gio-cookie-message',
  templateUrl: './cookie-message.component.html',
  styleUrls: ['./cookie-message.component.scss']
})
export class CookieMessageComponent extends CleanSubscriptions implements OnInit {

  @Output()
  accepted = new EventEmitter();

  view = 'message1';

  hideOnPaths = ['/legal/privacy'];

  _isVisible = true;
  _isSmall = false;



  @HostBinding('class.hidden') get hidden() {
    return !this._isVisible;
  }

  constructor(
    private router: Router,
    private sSize: ResponsiveService,
    private util: UtilService
  ) { super(); }

  ngOnInit(): void {

    this.subscribe = combineLatest([this.sSize.screenWidth$, this.router.events])
      .subscribe(([size, event]) => {
        this._isSmall = size < 701;
        if (event instanceof NavigationEnd) {
          this._isVisible = this.hideOnPaths.notIncludes(event.url);
        }
      });
  }

  async accept() {
    await this.util.preferences.set(BrowserPreference.COOKIE_ACCEPTED, { accepted_at: moment().toISOString() });
    this.accepted.emit();
  }

  showPrivacy() {
    this.router.navigate(['legal', 'privacy']);
  }

}
